import {useEffect, useState} from "react";
import {FacebookPixel} from "react-use-facebook-pixel";
import {useOrganizationConfig} from "../OrganizationConfig/useOrganizationConfig";

let facebookPixelSingleton: FacebookPixel | null = null;

const useFacebookPixel = () => {
  const {moduleConfig} = useOrganizationConfig();
  const pixelId = moduleConfig?.customValues?.pixelId;

  const [facebookPixel, setFacebookPixel] =
    useState<FacebookPixel | null>(null);

  useEffect(() => {
    // Only initialize in production
    if (process.env.NODE_ENV !== "production") {
      console.info("Facebook Pixel is only initialized in production");
      return;
    }

    if (!pixelId) {
      return;
    }

    if (!facebookPixelSingleton) {
      const initializeFacebookPixel = async () => {
        try {
          const pixel = new FacebookPixel({
            pixelID: pixelId,
            autoConfig: true,
            debug: false,
          });

          pixel.init({});
          facebookPixelSingleton = pixel;
          setFacebookPixel(pixel);
        } catch (error) {
          console.error("Failed to initialize Facebook Pixel", error);
        }
      };

      // noinspection JSIgnoredPromiseFromCall
      initializeFacebookPixel();
    } else {
      setFacebookPixel(facebookPixelSingleton);
    }
  }, [pixelId]);

  return facebookPixel;
};

export default useFacebookPixel;
